import { tns } from 'tiny-slider'

export const prevSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="1em" height="1em" fill="currentColor" aria-label="Prev" role="image" preserveAspectRatio="xMidYMid"><!--! Font Awesome Free 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc.--><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"/></svg>`;

export const nextSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="1em" height="1em" fill="currentColor" aria-label="Next" role="image" preserveAspectRatio="xMidYMid"><!--! Font Awesome Free 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc.--><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375-12.5-12.5-12.5-32.75 0-45.25L242.8 256 73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"/></svg>`;

const configPadrao = {
	items: 1,
	autoplay: true,
	loop: true,
	nav: false,
	controlsText: [
		prevSvg,
		nextSvg
	],
};

function createTnsSlider(selector, options) {
	const el = document.querySelector(selector)

	if (el == undefined || el == null) return

	tns({
		container: selector,
		...configPadrao,
		...options
	})
}

// PARCEIROS
createTnsSlider('.slider__parceiros', {
	controlsPosition: 'bottom',
	responsive: {
		500: {
			items: 2,
			gutter: 30
		},
		768: {
			items: 3
		},
		1200 : {
			items: 4
		}
	}
})

// SERVICOS
createTnsSlider('.slide__servicos', {
	axis: 'vertical',
	controlsPosition: 'bottom',
	responsive: {
		350 : {
			items: 1,
			axis: 'horizontal',
		},
		992 :{
			axis: 'vertical',
			swipeAngle: false,
			items: 3,
		}
	}
})

